// src/googleAnalytics.js

export const initGA = () => {
    const measurementId = process.env.REACT_APP_PUBLIC_GA_MEASUREMENT_ID;
    if (!measurementId) {
        console.error("Google Analytics Measurement ID not found");
        return;
    }

    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${measurementId}');
    `;
    document.head.appendChild(script2);
};